<template>
    <div class="col-md-4">
        <div class="list-group">
            <a v-for="(segment, key) in videos"
               :key="key"
               @click="clickVideo(segment, segment.model.slug)"
               :class="{'playing' : currentSegment.model.id == segment.model.id}"
               class="clickleable list-group-item flex-column justify-content-center p-2">

                <div class="d-flex w-100 justify-content-between">

                    <div>
                        <div class="d-flex align-items-center">
                            <h4 class="mb-0" v-text="segment.model.title"></h4>
                        </div>
                        <small class="font-weight-bold" :class="{
                                                            'text-success' : segment.status == 'Completed',
                                                            'text-danger' : segment.status == 'Not Started',
                                                            'text-info' : segment.status == 'In Progress'
                                                        }"
                               v-text="segment.status">
                        </small>
                    </div>

                    <div class="d-flex align-items-center justify-content-center badge badge-primary" style="min-width: 50px" v-text="toFixed(segment.progress) + '%'">
                    </div>

                </div>
            </a>
        </div>
    </div>
</template>
<style>
.playing{
    background: #fcf6bc91;
}
</style>
<script>

export default {

    props: {
        currentSegment:{
            type: Object,
            required: true,
        },
        segments: {
            type: Array,
            required: false,
        },
        course: {
            type: Object,
            required: false,
        }
    },

    data(){
        return {
            videos: this.segments,
        }
    },

    methods: {
        clickVideo(segment, key) {
            this.$emit('segment', segment, key)
        },

        toFixed(num) {
            return num.toFixed(0);
        }
    },

    watch: {
        segments() {
            this.videos = this.segments
        }
    },
}
</script>

